export default __webpack_public_path__ + "static/media/bannerContacto.ed2975dd.webp";